var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.layout == "purple"
    ? _c(
        "div",
        { staticClass: "static-partial" },
        [
          _c("div", { staticClass: "static-partial__title" }, [
            _c("b", [
              _vm._v(_vm._s(_vm._f("trans")("st_public.cheaters_header")))
            ])
          ]),
          _c("div", { staticClass: "static-partial__block" }, [
            _vm._m(0),
            _c("div", { staticClass: "static-partial__paragraph" }, [
              _c("b", { staticClass: "d-block" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("trans")(
                      "st_public.your_checkout_testimonials_title"
                    )
                  )
                )
              ]),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm._f("trans")(
                      "st_public.your_checkout_testimonials_message"
                    )
                  )
                )
              ])
            ])
          ]),
          _c("div", { staticClass: "static-partial__block" }, [
            _vm._m(1),
            _c("div", { staticClass: "static-partial__paragraph " }, [
              _c("b", { staticClass: "d-block" }, [
                _vm._v(
                  _vm._s(_vm._f("trans")("st_public.your_search_history_title"))
                )
              ]),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm._f("trans")("st_public.your_search_history_message")
                  )
                )
              ])
            ])
          ]),
          _c("div", { staticClass: "static-partial__block" }, [
            _vm._m(2),
            _c("div", { staticClass: "static-partial__paragraph " }, [
              _c("b", { staticClass: "d-block" }, [
                _vm._v(
                  _vm._s(_vm._f("trans")("st_public.your_satisfaction_title"))
                )
              ]),
              _c("p", [
                _vm._v(
                  _vm._s(_vm._f("trans")("st_public.your_satisfaction_message"))
                )
              ])
            ])
          ]),
          _c("featured-on", { attrs: { layout: "purple" } })
        ],
        1
      )
    : _c(
        "div",
        [
          _c("div", { staticClass: "text-center mb-3" }, [
            _c("strong", [
              _vm._v(_vm._s(_vm._f("trans")("st_public.cheaters_header")))
            ])
          ]),
          _c("div", { staticClass: "bg-light d-flex py-2" }, [
            _vm._m(3),
            _c("div", { staticClass: "d-inline-block " }, [
              _c("strong", { staticClass: "d-block" }, [
                _vm._v(
                  _vm._s(_vm._f("trans")("st_public.your_satisfaction_title"))
                )
              ]),
              _c("div", [
                _vm._v(
                  _vm._s(_vm._f("trans")("st_public.your_satisfaction_message"))
                )
              ])
            ])
          ]),
          _c("div", { staticClass: "bg-light d-flex py-2" }, [
            _vm._m(4),
            _c("div", { staticClass: "d-inline-block " }, [
              _c("strong", { staticClass: "d-block" }, [
                _vm._v(
                  _vm._s(_vm._f("trans")("st_public.your_search_history_title"))
                )
              ]),
              _c("div", [
                _vm._v(
                  _vm._s(
                    _vm._f("trans")("st_public.your_search_history_message")
                  )
                )
              ])
            ])
          ]),
          _c("div", { staticClass: "bg-light d-flex py-2" }, [
            _vm._m(5),
            _c("div", { staticClass: "d-inline-block " }, [
              _c("strong", { staticClass: "d-block" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("trans")(
                      "st_public.your_checkout_testimonials_title"
                    )
                  )
                )
              ]),
              _c("div", [
                _vm._v(
                  _vm._s(
                    _vm._f("trans")(
                      "st_public.your_checkout_testimonials_message"
                    )
                  )
                )
              ])
            ])
          ]),
          _c("featured-on")
        ],
        1
      )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "static-partial__icon" }, [
      _c("i", { staticClass: "fa fa-quote-right" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "static-partial__icon" }, [
      _c("i", { staticClass: "fa fa-lock" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "static-partial__icon" }, [
      _c("i", { staticClass: "fa fa-thumbs-up" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "d-inline-block text-center text-primary px-4 h5" },
      [_c("span", { staticClass: "fa fa-thumbs-up" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "d-inline-block text-center text-primary px-4 h5" },
      [_c("span", { staticClass: "fa fa-lock" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "d-inline-block text-center text-primary px-4 h5" },
      [_c("span", { staticClass: "fa fa-quote-right" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d3282c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d3282c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/CheckoutStaticPartial.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6d3282c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/CheckoutStaticPartial.vue
// module chunks = 9